module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lxm-tabs tabs is-centered is-boxed"
  }, [_c('ul', [_vm._l((_vm.tabs), function(tab) {
    return [_c('li', {
      class: {
        'is-active': tab.active
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.tabClicked(tab.to)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(tab.name))])])])]
  })], 2)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4d2c1c7f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4d2c1c7f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/common/LxmTabs.vue
// module id = 848
// module chunks = 0